import { useParams } from 'react-router-dom';
import { serviceData } from './data';
import { useState } from 'react';
import Carousel from './Carousel';

const ServiceDetails = () => {
  const [data1,setdata]=useState(serviceData)
  const { serviceId } = useParams();
  const useridx=parseInt(serviceId)
  const currentData=data1.find(item=>item.id===useridx)  
  // Fetch or display service details based on id
  return (
    <div>
<Carousel/>
    <div className='servicehelo'>
    <div className="servicesdetails">
    {/* Product Name Heading */}
    <h2 className="product-name"><strong>

    {currentData.name}
    </strong>
    </h2>
    <p>{currentData.about}</p>

      <br/>
      <br/>

      

      <h2>Here are some pictures of our service</h2>
      <br/>
      <div className="image-gallery">
        
       {currentData.image.map((img)=>{
         return(
           <div >
             <img 
            
            src={img} 
            
            
            />
          </div>
        )
      })}
</div>
      </div>
        
      </div>
      </div>
  );
};

export default ServiceDetails;
